import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class FlightReportsMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      range: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeType(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            bases_select: responseJson.data.bases_select,
            flight_types_select: responseJson.data.flight_types_select,
            clients_select: responseJson.data.clients_select,
            clients_full_select: responseJson.data.clients_full_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      contract_id: this.state.contract_id,
      client_id: this.state.client_id,
      contract_base_id: this.state.contract_base_id,
      flight_type_id: this.state.flight_type_id,
      flight_report_id: this.state.flight_report_id,
      flight_report_flight_number: this.state.flight_report_flight_number,
      status: this.state.status,
      range: this.state.range,
      exemption: this.state.exemption,
      payload: this.state.payload,
      aircraft_model_id: this.state.aircraft_model_id,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/pesquisa/restrito', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.main, headers: responseJson.data.headers, searched: self.state.range});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    var columns = null

    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.AnaliticoOuSintetico}:</label>
            <Select
              className=""
              name="range"
              value={this.state.range}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'range')}
              options={[
                {value: 1, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.AnaliticoPorTripulante},
                {value: 2, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.AnaliticoPorRelatorio},
                {value: 0, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.Sintetico},
              ]}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.SomenteAprovados}:</label>
            <Select
              className=""
              name="status"
              value={this.state.status}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'status')}
              options={[
                {value: 1, label: this.locale.general.sim},
                {value: 0, label: this.locale.general.nao},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.RelatorioDeVoo}:</label>
            <input type="text" name="flight_report_id" className="form-control" placeholder={this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.placeholder.InformeONumeroDoRelatorioDeVoo} value={this.state.flight_report_id} onChange={this.handleChange.bind(this, 'flight_report_id')} />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.NumeroDoVoo}:</label>
            <input type="text" name="flight_report_flight_number" className="form-control" placeholder={this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.placeholder.InformeONumeroDoVoo} value={this.state.flight_report_flight_number} onChange={this.handleChange.bind(this, 'flight_report_flight_number')} />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Aeronave}:</label>
            <Select
              className=""
              name="aircraft_id"
              value={this.state.aircraft_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
              options={this.state.aircrafts_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Frota}:</label>
            <Select
              className=""
              name="aircraft_model_id"
              value={this.state.aircraft_model_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
              options={this.state.aircraft_models_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Base}:</label>
            <Select
              className=""
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.TipoDeVoo}:</label>
            <Select
              className=""
              name="flight_type_id"
              value={this.state.flight_type_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'flight_type_id')}
              options={this.state.flight_types_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Contrato}:</label>
            <Select
              className=""
              name="contract_id"
              value={this.state.contract_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_id')}
              options={this.state.clients_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Isencao}:</label>
            <Select
              className=""
              name="exemption"
              value={this.state.exemption}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'exemption')}
              options={[
                {value: 0, label: this.locale.general.nao},
                {value: 1, label: this.locale.general.sim},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.CargaExterna}:</label>
            <Select
              className=""
              name="payload"
              value={this.state.payload}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'payload')}
              options={[
                {value: 0, label: this.locale.general.nao},
                {value: 1, label: this.locale.general.sim},
              ]}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Cliente}:</label>
            <Select
              className=""
              name="client_id"
              value={this.state.client_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'client_id')}
              options={this.state.clients_full_select}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.BasesContratual}:</label>
            <Select
              className=""
              name="contract_base_id"
              value={this.state.contract_base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_base_id')}
              options={this.state.bases_select}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      {self.state.searched === 0 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
              <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
              <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft_model_id'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota}</TableHeaderColumn>
              <TableHeaderColumn dataField={'base'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'client'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_report'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'exemption'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_land_time_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooDEPARR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'time_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooTempoTotal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'navigation_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooNavegacao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'ifr_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooInstrumento}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooNoturno}</TableHeaderColumn>
              <TableHeaderColumn dataField={'day_landings_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPousosDiurnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_landings_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPousosNoturnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'pax_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPAX}</TableHeaderColumn>
              <TableHeaderColumn dataField={'payload_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooCarga}</TableHeaderColumn>
              <TableHeaderColumn dataField={'fuel_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooConsumo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'refuels'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida}</TableHeaderColumn>
              <TableHeaderColumn dataField={'observations'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
      {self.state.searched === 1 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
              <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
              <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft_model_id'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota}</TableHeaderColumn>
              <TableHeaderColumn dataField={'base'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'client'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_report'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'exemption'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'duty'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.FB}</TableHeaderColumn>
              <TableHeaderColumn dataField={'arrival'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Apresentacao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'inscription'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Matricula}</TableHeaderColumn>
              <TableHeaderColumn dataField={'staff'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Tripulante}</TableHeaderColumn>
              <TableHeaderColumn dataField={'leg_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Etapa}</TableHeaderColumn>
              <TableHeaderColumn dataField={'departure_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Origem}</TableHeaderColumn>
              <TableHeaderColumn dataField={'arrival_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>Destino</TableHeaderColumn>
              <TableHeaderColumn dataField={'engine_start_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.HrPart}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEP}</TableHeaderColumn>
              <TableHeaderColumn dataField={'landing_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.ARR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engine_shutoff_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Corte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_land_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEPARR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'total_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoTotal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'navigation_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNavegacao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'ifr_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoInstrumento}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNoturno}</TableHeaderColumn>
              <TableHeaderColumn dataField={'day_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosDiurnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosNoturnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'starts'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Partidas}</TableHeaderColumn>
              <TableHeaderColumn dataField={'pax'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PAX}</TableHeaderColumn>
              <TableHeaderColumn dataField={'payload'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Carga}</TableHeaderColumn>
              <TableHeaderColumn dataField={'external_load_long_line'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaLongLine}</TableHeaderColumn>
              <TableHeaderColumn dataField={'external_load_short_line'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaShortLine}</TableHeaderColumn>
              <TableHeaderColumn dataField={'fuel_start'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelInicial}</TableHeaderColumn>
              <TableHeaderColumn dataField={'fuel_end'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelFinal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'refuels'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida}</TableHeaderColumn>
              <TableHeaderColumn dataField={'observations'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
      {self.state.searched === 2 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
              <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
              <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft_model_id'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota}</TableHeaderColumn>
              <TableHeaderColumn dataField={'base'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'client'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_report'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'exemption'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'leg_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Etapa}</TableHeaderColumn>
              <TableHeaderColumn dataField={'departure_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Origem}</TableHeaderColumn>
              <TableHeaderColumn dataField={'arrival_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Destino}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engine_start_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.HrPart}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEP}</TableHeaderColumn>
              <TableHeaderColumn dataField={'landing_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.ARR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engine_shutoff_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Corte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_land_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEPARR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'total_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoTotal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'navigation_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNavegacao}</TableHeaderColumn>
              <TableHeaderColumn dataField={'ifr_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoInstrumento}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNoturno}</TableHeaderColumn>
              <TableHeaderColumn dataField={'day_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosDiurnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'night_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosNoturnos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'starts'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Partidas}</TableHeaderColumn>
              <TableHeaderColumn dataField={'pax'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PAX}</TableHeaderColumn>
              <TableHeaderColumn dataField={'payload'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Carga}</TableHeaderColumn>
              <TableHeaderColumn dataField={'external_load_long_line'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaLongLine}</TableHeaderColumn>
              <TableHeaderColumn dataField={'external_load_short_line'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaShortLine}</TableHeaderColumn>
              <TableHeaderColumn dataField={'fuel_start'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelInicial}</TableHeaderColumn>
              <TableHeaderColumn dataField={'fuel_end'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelFinal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'refuels'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida}</TableHeaderColumn>
              <TableHeaderColumn dataField={'observations'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsMain;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportsMain.js